import { render, staticRenderFns } from "./AppTableRow.vue?vue&type=template&id=5806b67d&scoped=true&"
import script from "./AppTableRow.vue?vue&type=script&lang=ts&"
export * from "./AppTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./AppTableRow.vue?vue&type=style&index=0&id=5806b67d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5806b67d",
  null
  
)

export default component.exports